// extracted by mini-css-extract-plugin
module.exports = {"leaderSection":"leader-section_leaderSection__0Xt4K","leaderImagesDiv":"leader-section_leaderImagesDiv__QqshC"};